import { Navigate } from 'react-router-dom'
import { useAuthContext } from '../context/AuthContext'
import LoadingSpinner from './LoadingSpinner'

export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, profile, loading, profileLoading } = useAuthContext()

  if (loading || (user && profileLoading)) {
    return (
      <LoadingSpinner />
    )
  }

  if (!user) return <Navigate to="/signin" replace />
  if (profile?.role !== 'admin') return <Navigate to="/dashboard" replace />

  return <>{children}</>
}
